"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar;
  return {
    bookmark: {
      alignItems: "center",
      border: "1px solid ".concat((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main),
      borderRadius: theme.shape.borderRadius,
      display: "flex",
      justifyContent: "center",
      width: 48
    }
  };
});
var _default = styles;
exports.default = _default;